import React, { useEffect, useState, FC } from "react";
import { Button, message, Input, Tooltip, Form, Upload, Modal } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { formatNum, formatIntPoint, formatIntPoint1 } from "@/utils/utils"
import { useSaleSoDetailModel } from "./saleSoDetailModel";
import { globalPrompt } from "@/components/message";
import { ITopType, ITreeSelectData } from "@/types/ScmTypes";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, vinOption, getVinItem } from "@/model/globalModel";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum } from "@/types/ScmEnums";
import { debounce } from "lodash";
import { useSaleSoModel } from "../../saleSoModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { fileDownload } from "@/utils/exportFile";
import TextPriviewImage from "../../TextPriviewImage";
import { invoiceModel } from "../../InvoiceModel";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const { imageUrl } = invoiceModel();
    const { getSelectedDictOne, getTreeNodeName } = useDictModel();
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs, technicianData, getSettlementParty } = useGlobalModel();
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useSaleSoModel();
    const {
        addDesc,
        detailEditForm,
        detailAddForm,
        detailLookForm,
        vehicleEditAll,
        vehicleAddAll,
        initForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setVehicleAddAll,
        setVehicleEditAll,
        setDetailDataSource,
        supplementInsert,
        setConsumeHistoryModel,
        setConsumeHistoryVisible,
        verifyGoods,
        setRepairHistoryModel,
        formComputeRule,
        saveLoading, setSaveLoading,
        topButsControl,
        setWsConfirmModal,
        detailLookList,
        setSettleVisible
    } = useSaleSoDetailModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    let { salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;

    //单独控制调拨销不能修改的状态
    const [allocationDisabled, setallocationDisabled] = useState(false)
    useEffect(() => {
        setallocationDisabled(detailEditForm.status === DictCodeEnmu.SALE_STATUS_ALLOCATION)
    }, [detailEditForm.status])


    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("5-2-1") && resetAddCatch(mode);
            !findNav("5-2-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])

    const save = () => {
        if (!verifyGoods(mode)) return;
        let goods = mode === "add" ? detailAddList : detailDataSource
        let purcharseNum = goods.filter(item => item.num == 0)
        let totalDecreaseAmount: number = 0
        if (purcharseNum.length > 0) {
            globalPrompt("message", { text: `【${purcharseNum.map(item => item.materialName).join()}】的销售数量不能为0`, type: "error" })
            return
        }
        // 单项优惠金额总数不能大于1
        goods.forEach(item => {
            totalDecreaseAmount += Number(item.decreaseAmount)
        })
        if (totalDecreaseAmount >= 1) {
            globalPrompt("message", { text: '单项优惠的总金额不能大于1', type: "error" })
            return
        }
        // return
        IFormRef.current?.validateFields().then(async res => {
            let { fileList = [], saleUserCode, ...params } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                params.md5 = file?.uid
                params.fileName = file?.name
            } else {
                params.md5 = ''
                params.fileName = ''
            }
            let saleUserCodes = saleUserCode ? saleUserCode.toString() : ''
            let saleUser = saleUserCode ? technicianData.filter((el: any) => !!saleUserCode.find((ele: any) => ele === el.code))?.map((item: any) => item.name).toString() : ''
            if (mode === "add") {
                let { receivableAll } = addDesc;
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                // let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });

                // if (payType !== IVRMSettleTypeEnum.SETTLE_CASH && !parentInfo) {
                //     if (accountName && availableAmount >= receivableAll) {//有账户，但是额度大于开单金额的
                //         savsTips(`当前${accountName},授信额度为${availableAmount}是否确认？？`, true, { ...params, saleUser, saleUserCode: saleUserCodes })
                //     } else if (accountName && availableAmount < receivableAll) { //有账户，但是额度低于开单金额的
                //         savsTips(`当前${accountName},授信额度为${availableAmount}小于开单金额${receivableAll}，无法开单，是否确认？？`, false)
                //     } else if (!accountName) { //查对应没有账户的
                //         savsTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                //     }
                // } else {
                await insertSave({ ...params, saleUser, saleUserCode: saleUserCodes })
                // }
            } else if (mode === "edit") {
                let { id, saleCode } = detailEditForm
                const resData = await editDetail({ ...params, saleUser, saleUserCode: saleUserCodes, id, saleCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(saleCode as string, mode)
                }
            }
        })
    }
    const savsTips = (info: string, isSave: boolean, from: any = {}) => {
        globalPrompt("modal", {
            title: "销售单详情保存",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { isSave && await insertSave(from) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const insertSave = async (res: any) => {
        const resData = parentInfo ? await supplementInsert(res) : await insertDetail(res)
        if (resData) {
            globalPrompt("message", { text: `${parentInfo ? '补单' : '新增'}成功`, type: "success" });
            resetAddCatch(mode);
            setSelectedRowKeys([resData.id as string])
            setDescRows([resData])
            setSelectedRow(resData)
            resetAddCatch(mode)
            goBack();
        }
    }
    const goBack = () => {
        replaceNav(selectedNavId, "5-2")
    }
    const onRefresh = async () => {
        if (mode === 'add') {
            IFormRef.current?.resetFields()
            getVehicleAllList()
            setDetailAddForm(initForm)
            setDetailAddList([])

        } else if (mode === 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }

    const onDiscount = () => {
        let discountVal: string = "";
        globalPrompt("modal", {
            width: 380,
            title: "折扣",
            type: "info",
            text: <>
                <span>请输入折扣系数</span>
                <Input
                    onChange={(e) => { discountVal = e.target.value }}
                    suffix="%"
                />
            </>,
            okText: "确定",
            onOk: () => {
                discountVal = +formatNum(discountVal) + '';
                discountVal = +formatIntPoint(discountVal, 100, '折扣不能高于100%')  + '';
                var re = /^[0-9]+.?[0-9]*$/;
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject("输入的值不是数字，请重新输入")
                        message.error("输入的值不是数字，请重新输入")

                    } else {
                        resolve(discountVal)
                    }
                }).then(res => {
                    onSetDetailsTableDiscount(+discountVal)
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onSetDetailsTableDiscount = async (discount: number) => {
        let detailsList = mode === "add" ? detailAddList : detailDataSource
        let newDetailsList = detailsList.map((item) => {
            let num = mode === "add" ? parentInfo ? +formatIntPoint(item.num) : +formatIntPoint(item.num, item.inventoryNum, "选择数量>=可用库存数量") : parentInfo ? +formatIntPoint(item.num) : +formatIntPoint(item.num, item.termNum ? item.termNum : item.inventoryNum, "选择数量>=可用库存数量");  //数量
            let price = +formatIntPoint1(item.price, item.newPurPrice, `修改价格不应小于进货价${item.newPurPrice}`);  //价格
            price = +formatNum(price);
            let discountedAmount = +formatNum((num * price * discount) / 100)
            // let decreaseAmount = +formatIntPoint(item.decreaseAmount, 1, '单项优惠金额不能大于1元')
            let decreaseAmount = (item.decreaseAmount || 0) * 1
            let receivableAmount = +formatNum(discountedAmount - decreaseAmount)
            return {
                ...item,
                discountRate: discount,
                num,
                decreaseAmount,
                totalAmount: +formatNum(num * price),
                discountedAmount,
                receivableAmount
            }
        })
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList)
    }
    const disabledFromBtn = () => {
        let status = detailEditForm.status;
        if (mode === "look") return false;
        if (mode === "add") return true;

        if (mode === "edit" &&
            status === DictCodeEnmu.SALE_STATUS_STOCK_IO ||
            status === DictCodeEnmu.SALE_STATUS_SETTLE || status === "d-sale-status.paying"
        ) {
            return false
        }
        return true;
    }
    const onWhConfirm = () => {
        if (detailDataSource.length != 0 && mode === "edit") {
            setWsConfirmModal(true)
        }
        else if (detailLookList.length !== -1 && mode === "look") {
            setWsConfirmModal(true)
        } else {
            globalPrompt("message", { type: "error", text: `请添加商品详情` })
        }
    }
    const onSettle = () => {
        IFormRef?.current?.validateFields().then(async (res: any) => {
            setSettleVisible(true)
        })
    }
    const onReturnRo = () => {
        let str: string = ""
        globalPrompt("modal", {
            title: "整单退货",
            text: <Input placeholder="请输入退货原因" onChange={(e) => { str = e.target.value }} />,
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (str) {
                        resolve(str);
                    } else {
                        message.warning("请输入退货原因");
                        reject('请输入退货原因');
                    }
                }).then(async res => {
                    message.success("整单退货成功");
                    resetEditCatch();
                    replaceNav("5-2-2", "5-3-1", {
                        id: '', mode: "add", parentInfo: {
                            // mode,
                            // selectedNavId,
                            // id,
                            type: 'trunRo',
                            form: { ...detailEditForm, returnReason: str },
                            detailsList: detailDataSource.map(item => {
                                let { detailsId, ...params } = item;
                                return {
                                    ...params,
                                    saleNum: params.num,
                                    salePrice: params.price,
                                    detailId: detailsId

                                }
                            })
                        }
                    });

                });
            },
        })
    }
    const rightChildren = <>
        {
            mode === "edit" && <>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_CONFIRM_BILL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={onSettle}
                        disabled={topButsControl || detailEditForm.status === "sale.settle" || detailEditForm.status === "sale.stock-io"}
                    >确认结算</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_STOCK}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={onWhConfirm}
                        disabled={topButsControl || detailEditForm.status === "sale.stock-io" || detailEditForm.status === "d-sale-status.paying"}
                    >库房确认</Button>
                </YhAuth>
                {/* <YhAuth resCode={ResourceAuthEnum.S_S_ED_RETURN_ALL}> */}
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onReturnRo}
                    disabled={topButsControl || detailEditForm.status === "d-sale-status.paying" || !(detailEditForm.status === "sale.stock-io")}
                >转退单</Button>
                {/* </YhAuth> */}
            </>
        }
        {
            mode === "look" && <>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_CONFIRM_BILL}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        // disabled={topButsControl}
                        onClick={onSettle}
                    >结算查看</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_STOCK}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        // disabled={topButsControl}
                        onClick={onWhConfirm}
                    >出库查看</Button>
                </YhAuth>
            </>
        }
        {disabledFromBtn() &&
            <>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_DISC}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={onDiscount}
                    >快捷折扣</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.S_S_ED_SAVE}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        loading={saveLoading}
                        onClick={debounce(() => { save() }, 900)}
                    >{saveLoading ? '保存中' : '保存'}</Button>
                </YhAuth>
            </>
        }
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    //车辆类型
    const vehicleTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value });
    }
    //维修类型
    const maintenanceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ maintenanceTypeName: option.label, maintenanceTypeCode: option.value });
    }
    //结算方
    const settlementPartyChange = (value: string, option: ISelectOption) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value });
    }
    //客户类型
    const onTreeSelectChange = (value: string, option: ITreeSelectData) => {
        option && onChange({ customerTypeName: option.title, customerTypeCode: option.value });
    }
    //发票类型
    const invoiceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ invoiceTypeName: option.title, invoiceTypeCode: option.value });
    }
    //销售实体
    const bentityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }
    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }
    //销售类型
    const salesTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: undefined, priceTypeCode: undefined });
        if (value === ISalesTypeEnum.NORMAL_SALES) {
            option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: "零售价", priceTypeCode: "price-selection.retail" });
        }
        if (!value) {
            onChange({ salesTypeName: undefined, salesTypeCode: undefined, priceTypeName: undefined, priceTypeCode: undefined });
        }
        if (value) {
            alterListPrice(value === ISalesTypeEnum.NORMAL_SALES ? "price-selection.retail" : undefined, value, customerCode as string);
        }
    }
    //售价选择
    const priceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value });
        if (value) {
            alterListPrice(value, salesTypeCode, customerCode as string);
        }
    }
    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode: string | undefined, salesTypeCode: string, customerCode: string) => {
        let detailsList = mode == "add" ? detailAddList : detailDataSource;
        if (!detailsList.length) return;
        if (!salesTypeCode || !customerCode) {
            message.warning("请补全客户名称，销售类型才可以，对下列表格的价格数据进行更改");
            return false;
        }
        let newDetailsList = await Promise.all(detailsList.map(async item => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, decreaseAmount, retailPrice, num, ...params } = item as { latestPurPrice: number, decreaseAmount: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = 0;
            if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = await findPoDetailPrice(stockId, ["retailPrice"])
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.PETROLEUM:
                        newPrice = await findPoDetailPrice(stockId, ["petroleumPrice", "purchasePrice"], true);
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }
            return {
                ...item,
                num,
                price: newPrice,
                totalAmount: +formatNum(num * newPrice),
                discountedAmount: +formatNum((num * newPrice * discountRate) / 100),
                receivableAmount: +formatNum((num * newPrice * discountRate) / 100 - decreaseAmount),
            }
        }))
        // console.log(newDetailsList)
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList);
    }
    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId: string, priceType: string[], priceTypeLen?: boolean) => {
        let resultPrice: number = 0;
        await stockStatisticService.findId(stockId).then(async res => {
            let retData = await res.retData;
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]];

        })
        return resultPrice
    }
    useEffect(() => {
        getVehicleAllList()
    }, [mode])

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            shopId,
            pageSize: 2000,
            pageNum: 1
        }
        const { retData } = await vehicleService.pages(params)
        const { records } = retData
        let newRecords = records.map(item => {
            return {
                ...item,
                label: item.licensePlate,
                value: item.licensePlate
            }
        })
        mode === "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)
    }
    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (value && option) {
            let { contact, phone, address, categoryCode, categoryName } = getFindItem(value, CustomerData)
            option && onChange({
                customerName: option.label,
                customerCode: option.value,
                contact,
                phone,
                address,
                customerTypeCode: categoryCode,
                customerTypeName: categoryName,
                licensePlate: null,
                vehicleTypeCode: null,
                vehicleTypeName: null,
                vehicleModel: null,
                vin: null
            });
        }
        getVehicleAllList({ customerCode: option?.value as string })

    }
    //车辆牌照
    const vehicleChange = (value: string, option: ISelectOption) => {
        let VehicleIList = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {
            let { customerName, customerCode, licensePlate, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVehicleItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }
    //vin码
    const vinChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {

            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVinItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }
    const typeForm = {
        add: { ...detailAddForm },
        edit: { ...detailEditForm, saleUserCode: detailEditForm?.saleUserCode ? detailEditForm.saleUserCode.split(",") : [] },
        look: { ...detailLookForm, saleUserCode: detailEditForm?.saleUserCode ? detailEditForm.saleUserCode.split(",") : [] }
    }
    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id,
                    customerCode: typeForm[mode].customerCode
                }
            },
            true)
    }


    const onConsumption = () => {
        let { customerCode, customerName } = typeForm[mode]
        if (!customerCode) {
            return message.warning("请先选择客户")
        }
        setConsumeHistoryVisible(true)
        setConsumeHistoryModel({ customerName: customerName as string })
    }

    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="消费记录">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>
    </>
    const normFile = (e: UploadChangeParam) => {
        // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        // let isType: boolean = false
        // let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        // isType = filetypes?.includes(fileEnd) ?? false
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        // if (!isType) {
        //     e.fileList?.pop()
        // }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const [payTypeList, setPayTypeList] = useState<ISelectOption[]>([])
    useEffect(() => {
        // if( shopCode=='SHOP-M-00000016'||shopCode=='SHOP-M-00000017'||shopCode=='SHOP-M-00000018'){
        setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE))
        // }else{
        //     setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE).map((item)=>{
        //         return{...item,disabled:item.value=='settle-type.credit'?true:false}}))        }
    }, [])
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        // rightChildren,
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "销售单号",
            //     fieldName: "saleCode",
            //     disable: true,
            //     placeholder: "自动生成"
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goCustomer}>客户名称</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                onSelectChange: customerChange,
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择客户名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]

            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "销售类型",
                fieldName: "salesTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.SALES_TYPE),
                onSelectChange: salesTypeChange,
                rules: [{ required: true, message: "请选择销售类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                onSelectChange: bentityChange,
                rules: [{ required: true, message: "请输入销售实体" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算方",
                fieldName: "settlementPartyCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                rules: [{ required: true, message: "请选择结算方" }],
                hidden: mode === "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
                hidden: mode !== "look"
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
                allowClear: true,
                showSearch: true,
                options: payTypeList,
                rules: [{ required: true, message: "请选择结算类型" }],
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "售价选择",
                fieldName: "priceTypeCode",
                // disable: salesTypeCode !== ISalesTypeEnum.NORMAL_SALES,
                options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
                disable: true,
                // options:(()=>{debugger; return getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION)})(),
                onSelectChange: priceTypeChange,
            }, {
                type: FormItemTypeEnum.TreeSelect,
                allowClear: true,
                showSearch: true,
                fieldLabel: "客户类型",
                fieldName: "customerTypeCode",
                treeData: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE),
                onTreeSelectChange,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "address",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                disable: allocationDisabled,
                fieldName: "note",
                span: 4,
            },
            //  {
            //     type: FormItemTypeEnum.Button,
            //     fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
            //     fieldName: "none",
            //     span: 1,
            //     labelCol: { offset: 5 },
            // },  
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票人",
                fieldName: "invoiceOperator",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            },
            ...(typeForm[mode].invoiceNum ? [{
                type: FormItemTypeEnum.Button,
                fieldLabel: <a style={{ color: 'black' }}>发票号码：</a>,
                fieldName: "none",
                hidden: more,
                span: 2,
                labelCol: { offset: 10 },
            },
            {
                type: FormItemTypeEnum.Button,
                fieldLabel: typeForm[mode].invoiceNum ? <TextPriviewImage text={typeForm[mode].invoiceNum as string} previewList={typeForm[mode].invoiceMd5?.split(",")} imageUrl={imageUrl} /> : '自动带出',
                fieldName: "invoiceNum",
                hidden: more,
                span: 4,
                labelCol: { offset: 1 },
            }] : [
                {
                    type: FormItemTypeEnum.Input,
                    fieldLabel: "发票号码",
                    fieldName: "invoiceNum",
                    disable: true,
                    hidden: more,
                    placeholder: "自动带出",
                }
            ]),
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
                hidden: more,
                onSelectChange: invoiceTypeChange,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票上传时间",
                fieldName: "invoiceUploadTime",
                hidden: more,
                disable: true,
                placeholder: "自动带出",
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                mode: "multiple",
                fieldLabel: "销售人员",
                fieldName: "saleUserCode",
                options: transOptions(technicianData),
                hidden: more,
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "销售时间",
                showTime: true,
                fieldName: "saleTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单员",
                fieldName: "createUser",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "库管员",
                fieldName: "storekeeper",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "出库时间",
                fieldName: "stockIoTime",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算员",
                fieldName: "reckoner",
                hidden: more,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算时间",
                fieldName: "settleTime",
                hidden: more,
                disable: true,
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "VIN码",
            //     fieldName: "vin",
            //     allowClear: true,
            //     showSearch: true,
            //     onSelectChange: vinChange,
            //     options: mode === "add" ? vinOption(vehicleAddAll) : vinOption(vehicleEditAll),
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: '车辆类型',
            //     fieldName: "vehicleTypeCode",
            //     allowClear: true,
            //     showSearch: true,
            //     options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
            //     onSelectChange: vehicleTypeChange,
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: <span className="click-span" onClick={goVehicle}>车辆牌照</span>,
            //     fieldName: "licensePlate",
            //     allowClear: true,
            //     showSearch: true,
            //     options: mode === "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
            //     onSelectChange: vehicleChange,
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "工作小时",
            //     fieldName: "workingHours",
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "核销时间",
            //     fieldName: "payTime",
            //     hidden: more,
            //     disable: true,
            // }, {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "车辆型号",
            //     fieldName: "vehicleModel",
            //     hidden: more,
            //     disable: true,
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务备注",
                fieldName: "fmsNote",
                hidden: more,

            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单优惠",
                fieldName: "favorableAmount",
                rules: [{ type: 'number', transform: (value) => Math.abs(Number(value)), message: `当前不是一个有效数字`, }],
                hidden: more
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 16,
                hidden: mode == 'look' && !detailLookForm.md5 ? true : false,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            disabled={allocationDisabled || !disabledFromBtn()}
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )

                            }}
                        >
                            {mode !== 'look' && !allocationDisabled && disabledFromBtn() &&
                                <>
                                    <Button icon={<UploadOutlined />} >选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>}
                        </Upload>
                    </Form.Item>
                ),
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售类型",
                fieldName: "salesTypeName",
                hidden: true
            }
        ]
    };



    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updatEditFormVal(changedValues)
        setTopButsControl(true)

    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: !disabledFromBtn(),
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        销售单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].saleCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}